import { render } from "./ModelDetailPage.vue?vue&type=template&id=e47e54e2&scoped=true&ts=true"
import script from "./ModelDetailPage.vue?vue&type=script&lang=ts"
export * from "./ModelDetailPage.vue?vue&type=script&lang=ts"

import "./ModelDetailPage.vue?vue&type=style&index=0&id=e47e54e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e47e54e2"]])

export default __exports__